/* ==========================================================================
   ResProwendy Theme — theme.js
   Mobile menu, product gallery, quantity selectors, collection sorting
   ========================================================================== */

(function() {
  'use strict';

  // --- Mobile Menu ---
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const menuClose = document.getElementById('mobile-nav-close');
  const mobileNav = document.getElementById('mobile-nav');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function() {
      mobileNav.classList.add('mobile-nav--open');
    });
  }

  if (menuClose && mobileNav) {
    menuClose.addEventListener('click', function() {
      mobileNav.classList.remove('mobile-nav--open');
    });
  }

  // --- Product Image Gallery ---
  const mainImage = document.getElementById('product-main-image');
  const thumbnails = document.querySelectorAll('.product-thumb');

  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const url = this.getAttribute('data-image-url');
      if (mainImage && url) {
        mainImage.src = url;
        thumbnails.forEach(function(t) { t.classList.remove('product-thumb--active'); });
        this.classList.add('product-thumb--active');
      }
    });
  });

  // --- Quantity Selectors ---
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.qty-minus, .qty-plus');
    if (!btn) return;

    const container = btn.closest('.quantity-selector');
    if (!container) return;

    const input = container.querySelector('.qty-input');
    if (!input) return;

    let value = parseInt(input.value, 10) || 1;

    if (btn.classList.contains('qty-minus')) {
      value = Math.max(1, value - 1);
    } else {
      value = value + 1;
    }

    input.value = value;

    // Update add-to-cart button price if on product page
    updateCartButtonPrice(value);
  });

  function updateCartButtonPrice(qty) {
    const addBtn = document.querySelector('.product-add-to-cart');
    if (!addBtn) return;

    const priceEl = document.querySelector('.product-price-current');
    if (!priceEl) return;

    const priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
    const price = parseFloat(priceText);
    if (isNaN(price)) return;

    const total = (price * qty).toFixed(2);
    addBtn.textContent = 'Add to Cart \u2014 $' + total;
  }

  // --- Collection Sorting ---
  const sortSelect = document.getElementById('collection-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // --- Sticky Add to Cart (mirrors main form) ---
  const stickyBtn = document.getElementById('sticky-add-to-cart');
  const productForm = document.getElementById('product-form');
  if (stickyBtn && productForm) {
    stickyBtn.addEventListener('click', function() {
      productForm.submit();
    });
  }

  // --- Meta Pixel event stubs ---
  window.ResProwendyTracking = {
    viewContent: function(productId, productName, value) {
      if (typeof fbq === 'function') {
        fbq('track', 'ViewContent', {
          content_ids: [productId],
          content_name: productName,
          content_type: 'product',
          value: value,
          currency: 'USD'
        });
      }
    },
    addToCart: function(productId, productName, value, quantity) {
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
          content_ids: [productId],
          content_name: productName,
          content_type: 'product',
          value: value,
          currency: 'USD',
          num_items: quantity
        });
      }
    },
    initiateCheckout: function(value, numItems) {
      if (typeof fbq === 'function') {
        fbq('track', 'InitiateCheckout', {
          value: value,
          currency: 'USD',
          num_items: numItems
        });
      }
    }
  };

})();
